import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/global.css';
import { SettingsProvider } from './features/settings'; // <-- IMPORT
import { reloadOnceForRecoverableLoadError } from './utils/reloadOnError';

// Lazy load Sentry ONLY when an error occurs (saves 437KB from initial bundle)
let sentryLoaded = false;
const loadAndReportToSentry = async (error: Error | string, source?: string) => {
  if (sentryLoaded || !import.meta.env.VITE_SENTRY_DSN) return;

  try {
    sentryLoaded = true;
    const Sentry = await import('@sentry/react');
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
      // Disable replay for on-demand loading (too heavy)
    });

    // Report the error that triggered the load
    if (error instanceof Error) {
      Sentry.captureException(error);
    } else {
      Sentry.captureMessage(`${error} at ${source || 'unknown'}`);
    }
  } catch (e) {
    console.error('Failed to load Sentry:', e);
  }
};

// Global error handler - loads Sentry only when an error occurs
window.onerror = (message, source, _lineno, _colno, error) => {
  if (reloadOnceForRecoverableLoadError(error || message)) {
    return true;
  }

  loadAndReportToSentry(error || String(message), source ?? undefined);
};

// Promise rejection handler
window.onunhandledrejection = event => {
  if (reloadOnceForRecoverableLoadError(event.reason)) {
    event.preventDefault();
    return;
  }

  loadAndReportToSentry(event.reason || 'Unhandled Promise Rejection');
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SettingsProvider>
      {' '}
      {/* <-- WRAP your App */}
      <App />
    </SettingsProvider>
  </React.StrictMode>
);
